export class ProductPromoMin {
  id: number;
  name: string;
}
